// Back to Top Button
let windowScrollPosition = 0;
const threshold = 350;

$(window).scroll(function () {
    windowScrollPosition = $(this).scrollTop();

    if (windowScrollPosition > threshold && collision() == true)
        $('#back-to-top').fadeOut();
    else if (windowScrollPosition > threshold && collision() == false)
        $('#back-to-top').fadeIn();
    else
        $('#back-to-top').fadeOut();
});

function collision() {
    if ($('.next-click').length < 1)
        return false;

    let nextButton = $('.next-click');
    let backToTop = $('#back-to-top');

    let ol1 = nextButton.offset().left;
    let ot1 = nextButton.offset().top;
    let oh1 = nextButton.outerHeight(true);
    let ow1 = nextButton.outerWidth(true);

    let b1 = ot1 + oh1;
    let r1 = ol1 + ow1;

    let ol2 = backToTop.offset().left;
    let ot2 = backToTop.offset().top;
    let oh2 = backToTop.outerHeight(true);
    let ow2 = backToTop.outerWidth(true);

    let b2 = ot2 + oh2;
    let r2 = ol2 + ow2;

    if (b1 < ot2 || ot1 > b2 || r1 < ol2 || ol1 > r2)
        return false;

    return true;
}

// scroll body to 0px on click
$('#back-to-top').click(function () {
    $('body,html').animate({
        scrollTop: 0
    }, 400);
    return false;
});

export { windowScrollPosition }
